import React from "react";
import "../Admin/admin.css";
import { MdStackedBarChart } from "react-icons/md";
function Admin() {
  return (
    <>
      <p className="Admin_headnig">Welcome To MexCargo Software</p>
      {/* <div className="Admin_container">
        <div className="Admin_container_left">
          <div className="admin_lead_logo">
            <MdStackedBarChart className="admin_logo_icon" />
          </div>
          <p>Lead Management</p>
        </div>
        <div className="Admin_container_right">
          <h1>Admin</h1>
          <p>Admin Panel</p>
        </div>
      </div> */}
    </>
  );
}

export default Admin;
